import axios from "axios";
import { API } from "@/lib/api";

// Sessão de parceiro: cookies próprios (path /api/partner), separados do Backoffice.
export const partnerApi = axios.create({ baseURL: `${API}/partner`, withCredentials: true });

const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/set-password", "/auth/forgot-password", "/auth/token"];
let refreshing = null;

partnerApi.interceptors.response.use(
    (r) => r,
    async (error) => {
        const cfg = error.config || {};
        if (error.response?.status !== 401 || cfg._retried || NO_RETRY.some((p) => (cfg.url || "").startsWith(p))) {
            return Promise.reject(error);
        }
        cfg._retried = true;
        try {
            refreshing = refreshing || partnerApi.post("/auth/refresh").finally(() => { refreshing = null; });
            await refreshing;
        } catch {
            return Promise.reject(error);
        }
        return partnerApi(cfg);
    },
);

export const partnerFileUrl = (id) => `${API}/partner/files/${id}`;
export const partnerCoverUrl = (o) => (o?.cover_version ? `${API}/partner/obras/${o.lead_id}/cover?v=${o.cover_version}` : "");
export const adminPartnerFileUrl = (id, original = false) => `${API}/admin/partner-files/${id}${original ? "?original=1" : ""}`;

export function errorText(e, fallback = "Ocorreu um erro. Tente novamente.") {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
    return fallback;
}

export function formatDay(day, opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" }) {
    if (!day) return "";
    const dt = new Date(`${day}T12:00:00`);
    return isNaN(dt) ? day : dt.toLocaleDateString("pt-PT", opts);
}

export function formatDateTime(iso) {
    const dt = iso ? new Date(iso) : null;
    if (!dt || isNaN(dt)) return "";
    return dt.toLocaleString("pt-PT", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function todayLisbon() {
    return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Lisbon" }).format(new Date());
}

export const UPDATE_STATUS = {
    pending: { label: "Pendente de validação", cls: "bg-amber-100 text-amber-900" },
    changes_requested: { label: "Correção pedida", cls: "bg-orange-100 text-orange-900" },
    approved: { label: "Aprovada e publicada", cls: "bg-emerald-100 text-emerald-800" },
    rejected: { label: "Rejeitada", cls: "bg-stone-200 text-stone-700" },
};
